import {Stack} from "@mui/material";
import {ImageEffectCard} from "../widgets/ImageEffectCard.tsx";
import {useAppDispatch, useAppSelector} from "../app/store/hooks";
import {setSelectedPreset} from "../app/store/slices/generationSlice";
import {EffectType} from "../shared/types/EffectType";
import {CarouselWidget} from "../widgets/CarouselWidget.tsx";
import {SwiperSlide} from "swiper/react";
import {useCallback} from "react";

export const ImageEffects = () => {
    const dispatch = useAppDispatch();
    const imageEffects = useAppSelector((state) => state.presets.imageEffects);

    const handleImageEffectClick = useCallback((effect: EffectType) => {
        dispatch(setSelectedPreset(effect));
    }, [dispatch]);

    return (
        <Stack width={'100%'} spacing={2}>
            <CarouselWidget title={'Image'} titleType={'subTitle'} height={'175px'} autoPlay>
                {Array.from({length: Math.ceil(imageEffects.length / 2)}, (_, i) => imageEffects.slice(i * 2, i * 2 + 2)).map((pair, index) => (
                    <SwiperSlide key={index} style={{width: 'auto', height: '170px'}}>
                        <Stack direction="column" spacing={1}>
                            {pair.map((effect) => (
                                <ImageEffectCard key={effect.id} effect={effect} onClick={() => handleImageEffectClick(effect)} />
                            ))}
                        </Stack>
                    </SwiperSlide>
                ))}
            </CarouselWidget>
        </Stack>
    )
};
